export default __webpack_public_path__ + "static/media/register.50c6bc55.jpg";